import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { NoContentComponent } from './no-content';
import { LoginComponent } from './pages/login';
import { AuthGuard } from './services/security/auth-guard.service';

export const routes: Routes = [
  { path: '',       loadChildren: () => System.import('C:\\BuildAgent\\work\\28ae12f7a44bab3d\\src\\app\\pages\\pages.module')  .then( (module: any) => module['PagesModule'] ), canActivate: [AuthGuard] },
  { path: '',       redirectTo: '', pathMatch: 'full'},
  { path: 'login',  component: LoginComponent},
  { path: 'error',  component: NoContentComponent },
  { path: '**',     component: NoContentComponent }
];

export const AppRoutes = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/app.routes.ts